export class ProgramValue {
  public label: string;
  public name: string;
  public value: string;
}
